import { useState, useEffect, useContext } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { createOpenSeadragon } from "../viewer/Custom-OpenSeadragon";

import { currentPostAtom, currentSlideAtom } from "../../atom";
import { ViewerContext } from "../../page/Viewer";
import { getSlideData, postAnnotation, Slide } from "../../api/slideAPI";
import { getSlideMpp } from "../../api/deepzoomAPI";
import styled from "styled-components";

interface Props {
  postId: number;
  slide: Slide;
}

const Viewer = ({ postId, slide }: Props) => {
  const [viewer, setViewer] = useState<any>(null);
  const { userCustomSet, setUserCustomSet } = useContext(ViewerContext);

  const [currentSlide, setCurrentSlide] = useRecoilState(currentSlideAtom);
  const currentPost = useRecoilValue(currentPostAtom);

  const getAnnotationList = async () => {
    if (userCustomSet?.useAnnotation) {
      const data = await getSlideData(slide.slideId);
      
      setCurrentSlide(data);
    } else {
      return null;
    }
  };

  const saveAnnotation = async (
    annotationPath: any,
    annotationName: any,
    rulerValue: any,
  ) => {
    if (rulerValue)
      await postAnnotation(
        slide.slideId,
        annotationPath,
        `${annotationName} / (${rulerValue}mm)`,
      );
    else
      await postAnnotation(
        slide.slideId,
        annotationPath,
        annotationName,
      );
  };

  const getMpp = async () => {
    return await getSlideMpp(currentPost.id, slide.filename);
  };

  useEffect(() => {
    if (viewer) {
      viewer.open(
        process.env.REACT_APP_DEEPZOOM_URL +
          `/none/${postId}/${slide.filename}` +
          ".dzi"
      );
    }
  }, [ viewer ]);

  useEffect(() => {
    if(!currentSlide?.annotations) return;
    if (viewer) {
      const pathList = [];
      for (const path of currentSlide?.annotations) {
        const annoInfo = JSON.parse(JSON.stringify(path.annoInfo));
        annoInfo[1].id = `annotation${path.annoId}`;
        annoInfo[1].label = path.content;
        pathList.push(annoInfo);
      }
      viewer.setAnnotation(pathList);
    }
  }, [currentSlide]);

  useEffect(() => {
    viewer && viewer.destroy();
    setViewer(
      createOpenSeadragon({
        showScalebar: false,
        useRotationSlider: true,
        useFiltering: false,
        showNavigator: false,
        useCapture: false,
        saveAnnotation: true,
        // getSlideMpp: () => {},
        // getAnnotations: () => {},
        // addAnnotation: () => {},
        getSlideMpp: getMpp,
        getAnnotations: getAnnotationList,
        addAnnotation: saveAnnotation,
        annotationClickEvent: (event: React.MouseEvent<HTMLElement>) => {},
        isAnno: true,
      })
    );
  }, [ slide ]);

  return (
    <>
      <StOpenseadragon id="openseadragon" style={{ width: "80%", height: "70vh", margin: "0 auto" }} />
    </>
  );
};

export default Viewer;

interface StOpenseadragonProps {
  selectedAnnotation?: number;
}

const StOpenseadragon = styled('div')<StOpenseadragonProps>(({ theme, selectedAnnotation }) => ({
  width: '100%',
  height: '100%',

  '& .annotation': {
    cursor: 'pointer'
  },

  [`& #annotation${selectedAnnotation}`]: {
    // stroke: theme.palette.primary.main,
    // fill: 'rgba(242, 244, 230, 0.3)'
  },

  '& .osd-annotation-label': {
    stroke: 'black',
    fill: 'white',
    // stroke: 'black',
    // fill: 'yellow',
    strokeWidth: '0.15px', // 라벨 테두리 굵기
    fontSize: '0.65px', // 라벨 사이즈 
    pointerEvents: 'none',
    userSelect: 'none',
    paintOrder: 'stroke fill',
    maxWidth:"10px",
  }
}));